// PeptideVault v6.5 — Simulator + emergency card

// ══════════════════════════════════════════════════════
// RENDER: PROTOCOL SIMULATOR
// ══════════════════════════════════════════════════════

function runSimulation(params) {
  const { peptideName, dosePerInjection, doseUnit, frequency, concentrationMg, vialSizeMl, vialCost, startDate, durationWeeks, missedDoses, syringeSupplyName } = params
  const start = new Date(startDate)
  const days = durationWeeks * 7
  const end = new Date(start.getTime() + days * 86400000)

  // Calculate injection dates based on frequency
  const injDates = []
  const freqDays = frequency === 'daily' ? 1 : frequency === 'eod' ? 2 : frequency === 'e3d' ? 3 : frequency === 'weekly' ? 7 : frequency === 'biweekly' ? 14 : +frequency || 7
  let d = new Date(start)
  let injCount = 0
  while (d <= end) {
    injCount++
    if (missedDoses > 0 && injCount <= missedDoses) {
      injDates.push({ date: localDateStr(d), missed: true })
    } else {
      injDates.push({ date: localDateStr(d), missed: false })
    }
    d = new Date(d.getTime() + freqDays * 86400000)
  }

  const actualInjections = injDates.filter(i => !i.missed)
  const totalDoseMg = actualInjections.length * dosePerInjection

  // Vial calculation
  const mgPerVial = concentrationMg * vialSizeMl
  const vialsNeeded = mgPerVial > 0 ? Math.ceil(totalDoseMg / mgPerVial) : 0
  const totalCost = vialsNeeded * (vialCost || 0)
  const productRemaining = mgPerVial > 0 ? (vialsNeeded * mgPerVial) - totalDoseMg : 0

  // Syringe calculation
  const syringesNeeded = actualInjections.length

  // Check inventory
  const peptide = S.peptides.find(p => p.name.toLowerCase() === peptideName.toLowerCase())
  const currentVials = peptide ? peptideQty(peptide) : 0
  const vialsShort = Math.max(0, vialsNeeded - currentVials)

  // Check supply inventory for syringes
  let currentSyringes = 0
  if (syringeSupplyName) {
    const supply = (S.injectionSupplies||[]).find(s => s.name.toLowerCase().includes(syringeSupplyName.toLowerCase()))
    if (supply) currentSyringes = injSupplyTotalQty(supply)
  }
  const syringesShort = Math.max(0, syringesNeeded - currentSyringes)

  // Vial expiry check
  const expiringVials = []
  if (peptide) {
    for (const sk of (peptide.skus||[])) {
      if (sk.expiryDate && sk.expiryDate < localDateStr(end) && skuQty(sk) > 0) {
        expiringVials.push({ vendor: sk.vendor, lot: sk.lotNumber, expiry: sk.expiryDate, qty: skuQty(sk) })
      }
    }
  }

  // Overlap with other protocols (from cycle timeline)
  const overlaps = []
  const userId = S._simUser || 'todd'
  const timeline = getUserTimeline(userId)
  if (timeline) {
    for (const c of timeline.compounds) {
      if (c.name.toLowerCase() === peptideName.toLowerCase()) continue
      const cycles = deriveCycles(c.entries)
      for (const cyc of cycles) {
        if (cyc.start <= localDateStr(end) && cyc.end >= startDate) {
          overlaps.push({ name: c.name, start: cyc.start, end: cyc.end, dosages: cyc.dosages })
        }
      }
    }
  }

  // Vial depletion timeline
  const vialTimeline = []
  let remainingMg = mgPerVial
  let vialNum = 1
  for (const inj of actualInjections) {
    remainingMg -= dosePerInjection
    if (remainingMg <= 0 && vialNum < vialsNeeded) {
      vialTimeline.push({ date: inj.date, event: `Vial ${vialNum} depleted`, vial: vialNum })
      vialNum++
      remainingMg = mgPerVial + remainingMg // carry negative
    }
  }

  return {
    injDates, actualInjections, totalDoseMg, vialsNeeded, totalCost, productRemaining,
    syringesNeeded, currentVials, vialsShort, currentSyringes, syringesShort,
    expiringVials, overlaps, vialTimeline, durationWeeks, doseUnit, mgPerVial, startDate,
    endDate: localDateStr(end)
  }
}

function renderSimulatorTab() {
  const activeUsers = (S.users||[]).filter(u => u.active)
  const currentUser = S._simUser || (activeUsers[0]?.id || '')
  const peptideNames = [...S.peptides].sort((a,b)=>a.name.localeCompare(b.name)).map(p=>p.name)

  // Simulation state
  if (!S._sim) S._sim = { peptideName:'', dose:5, unit:'mg', freq:'weekly', conc:5, vialMl:3, cost:0, start:localDateKey(), weeks:12, missed:0, syringe:'U-100 Syringe' }
  if (!S._simB) S._simB = null // scenario B for comparison
  const sim = S._sim

  const resultA = sim.peptideName ? runSimulation({
    peptideName: sim.peptideName, dosePerInjection: +sim.dose, doseUnit: sim.unit,
    frequency: sim.freq, concentrationMg: +sim.conc, vialSizeMl: +sim.vialMl,
    vialCost: +sim.cost, startDate: sim.start, durationWeeks: +sim.weeks,
    missedDoses: +sim.missed, syringeSupplyName: sim.syringe
  }) : null

  const resultB = S._simB?.peptideName ? runSimulation({
    peptideName: S._simB.peptideName, dosePerInjection: +S._simB.dose, doseUnit: S._simB.unit,
    frequency: S._simB.freq, concentrationMg: +S._simB.conc, vialSizeMl: +S._simB.vialMl,
    vialCost: +S._simB.cost, startDate: S._simB.start, durationWeeks: +S._simB.weeks,
    missedDoses: +S._simB.missed, syringeSupplyName: S._simB.syringe
  }) : null

  function renderSimForm(prefix, s) {
    return `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">
      <div class="form-group"><label class="form-label" style="font-size:11px">Peptide</label>
        <select class="form-input" style="font-size:12px" onchange="S.${prefix}.peptideName=this.value;render()">
          <option value="">— Select —</option>
          ${peptideNames.map(n => `<option ${s.peptideName===n?'selected':''}>${esc(n)}</option>`).join('')}
        </select></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Dose per injection</label>
        <div style="display:flex;gap:4px"><input class="form-input" type="number" step="0.1" style="font-size:12px;flex:1" value="${s.dose}" oninput="S.${prefix}.dose=this.value;render()">
        <select class="form-input" style="font-size:12px;width:70px" onchange="S.${prefix}.unit=this.value;render()">
          ${['mg','mcg','IU','units'].map(u => `<option ${s.unit===u?'selected':''}>${u}</option>`).join('')}
        </select></div></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Frequency</label>
        <select class="form-input" style="font-size:12px" onchange="S.${prefix}.freq=this.value;render()">
          ${[['daily','Daily'],['eod','Every other day'],['e3d','Every 3 days'],['weekly','Weekly'],['biweekly','Every 2 weeks']].map(([v,l]) => `<option value="${v}" ${s.freq===v?'selected':''}>${l}</option>`).join('')}
        </select></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Duration (weeks)</label>
        <input class="form-input" type="number" min="1" style="font-size:12px" value="${s.weeks}" oninput="S.${prefix}.weeks=this.value;render()"></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Concentration (mg/mL)</label>
        <input class="form-input" type="number" step="0.1" style="font-size:12px" value="${s.conc}" oninput="S.${prefix}.conc=this.value;render()"></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Vial Size (mL)</label>
        <input class="form-input" type="number" step="0.1" style="font-size:12px" value="${s.vialMl}" oninput="S.${prefix}.vialMl=this.value;render()"></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Cost per Vial ($)</label>
        <input class="form-input" type="number" step="1" style="font-size:12px" value="${s.cost}" oninput="S.${prefix}.cost=this.value;render()"></div>
      <div class="form-group"><label class="form-label" style="font-size:11px">Start Date</label>
        <input class="form-input" type="date" style="font-size:12px" value="${s.start}" oninput="S.${prefix}.start=this.value;render()"></div>
    </div>
    <div style="margin-top:8px;padding:8px 10px;background:var(--bg2);border-radius:var(--r2)">
      <div style="font-size:11px;font-weight:700;color:var(--text3);margin-bottom:6px">What-If Scenarios</div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">
        <div class="form-group"><label class="form-label" style="font-size:11px">Missed doses (from start)</label>
          <input class="form-input" type="number" min="0" style="font-size:12px" value="${s.missed}" oninput="S.${prefix}.missed=this.value;render()"></div>
        <div class="form-group"><label class="form-label" style="font-size:11px">Syringe type</label>
          <select class="form-input" style="font-size:12px" onchange="S.${prefix}.syringe=this.value;render()">
            ${(S.injectionSupplies||[]).filter(sup=>sup.isSyringeNeedle).map(sup => `<option ${s.syringe===sup.name?'selected':''}>${esc(sup.name)}</option>`).join('')}
            <option ${!s.syringe?'selected':''} value="">— none —</option>
          </select></div>
      </div>
    </div>`
  }

  function renderSimResults(r, label) {
    if (!r) return '<div style="color:var(--text4);text-align:center;padding:24px">Select a peptide to simulate</div>'
    return `
    <div style="font-size:12px">
      <!-- Key metrics -->
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:12px">
        <div style="background:var(--bg2);padding:10px;border-radius:var(--r2);text-align:center">
          <div style="font-size:22px;font-weight:700;color:var(--blue)">${r.vialsNeeded}</div>
          <div style="font-size:10px;color:var(--text3)">Vials Needed</div>
        </div>
        <div style="background:var(--bg2);padding:10px;border-radius:var(--r2);text-align:center">
          <div style="font-size:22px;font-weight:700;color:var(--green)">${r.syringesNeeded}</div>
          <div style="font-size:10px;color:var(--text3)">Syringes</div>
        </div>
        <div style="background:var(--bg2);padding:10px;border-radius:var(--r2);text-align:center">
          <div style="font-size:22px;font-weight:700;color:${r.totalCost?'var(--amber)':'var(--text4)'}">$${r.totalCost.toFixed(0)}</div>
          <div style="font-size:10px;color:var(--text3)">Total Cost</div>
        </div>
      </div>

      <!-- Detail rows -->
      <div style="display:flex;flex-direction:column;gap:3px">
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Protocol</span>
          <span>${r.actualInjections.length} injections over ${r.durationWeeks} weeks (${r.startDate} → ${r.endDate})</span>
        </div>
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Total product used</span>
          <span>${r.totalDoseMg.toFixed(1)} ${r.doseUnit}</span>
        </div>
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Product per vial</span>
          <span>${r.mgPerVial.toFixed(1)} ${r.doseUnit}</span>
        </div>
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Product remaining (last vial)</span>
          <span>${r.productRemaining.toFixed(1)} ${r.doseUnit}</span>
        </div>
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Current inventory</span>
          <span style="color:${r.vialsShort?'var(--red)':'var(--green)'}">${r.currentVials} vials on hand${r.vialsShort ? ` (${r.vialsShort} short)` : ' ✓'}</span>
        </div>
        ${r.syringesNeeded ? `
        <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid var(--border)">
          <span style="color:var(--text3)">Syringe inventory</span>
          <span style="color:${r.syringesShort?'var(--red)':'var(--green)'}">${r.currentSyringes} on hand${r.syringesShort ? ` (${r.syringesShort} short)` : ' ✓'}</span>
        </div>` : ''}
      </div>

      ${r.expiringVials.length ? `
      <div style="margin-top:10px;padding:8px;background:var(--redL,#fff0f0);border-radius:var(--r2);border-left:3px solid var(--red)">
        <div style="font-weight:700;font-size:11px;color:var(--red);margin-bottom:4px">⚠ Vials expiring during protocol</div>
        ${r.expiringVials.map(v => `<div style="font-size:11px">${esc(v.vendor||'')} Lot ${esc(v.lot||'?')} — expires ${v.expiry} (${v.qty} vials)</div>`).join('')}
      </div>` : ''}

      ${r.overlaps.length ? `
      <div style="margin-top:10px;padding:8px;background:var(--blueL);border-radius:var(--r2)">
        <div style="font-weight:700;font-size:11px;color:var(--blue2);margin-bottom:4px">Overlapping protocols</div>
        ${r.overlaps.map(o => `<div style="font-size:11px">${esc(o.name)} (${o.dosages.join(', ')}) — ${o.start} to ${o.end}</div>`).join('')}
      </div>` : ''}

      ${r.vialTimeline.length ? `
      <div style="margin-top:10px">
        <div style="font-weight:700;font-size:11px;color:var(--text3);margin-bottom:4px">Vial depletion timeline</div>
        ${r.vialTimeline.map(v => `<div style="font-size:11px;padding:2px 0">${v.date} — ${v.event}</div>`).join('')}
      </div>` : ''}
    </div>`
  }

  const comparing = S._simB !== null

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Protocol Simulator</h2>
      <div class="spacer"></div>
      ${activeUsers.length > 1 ? activeUsers.map(u => `<button class="btn btn-sm ${currentUser===u.id?'btn-primary':'btn-secondary'}" onclick="S._simUser='${u.id}';render()">${esc(u.name)}</button>`).join('') : ''}
      <button class="btn btn-sm ${comparing?'btn-secondary':'btn-primary'}" onclick="S._simB=${comparing?'null':JSON.stringify({...sim}).replace(/'/g,"\\'")};render()">${comparing ? 'Remove Comparison' : '+ Compare Scenario'}</button>
    </div>

    <div style="display:grid;grid-template-columns:${comparing?'1fr 1fr':'1fr'};gap:16px">
      <!-- Scenario A -->
      <div>
        <div class="card" style="margin-bottom:12px">
          <div class="card-header"><div class="card-title">${comparing ? 'Scenario A' : 'Protocol Parameters'}</div></div>
          <div class="card-body">${renderSimForm('_sim', sim)}</div>
        </div>
        <div class="card">
          <div class="card-header"><div class="card-title">${comparing ? 'Scenario A Results' : 'Simulation Results'}</div></div>
          <div class="card-body">${renderSimResults(resultA, 'A')}</div>
        </div>
      </div>

      ${comparing ? `
      <!-- Scenario B -->
      <div>
        <div class="card" style="margin-bottom:12px">
          <div class="card-header"><div class="card-title">Scenario B</div></div>
          <div class="card-body">${renderSimForm('_simB', S._simB)}</div>
        </div>
        <div class="card">
          <div class="card-header"><div class="card-title">Scenario B Results</div></div>
          <div class="card-body">${renderSimResults(resultB, 'B')}</div>
        </div>
      </div>` : ''}
    </div>

    ${comparing && resultA && resultB ? `
    <!-- Side-by-side comparison -->
    <div class="card" style="margin-top:16px">
      <div class="card-header"><div class="card-title">Comparison</div></div>
      <div class="card-body">
        <div style="display:grid;grid-template-columns:2fr 1fr 1fr;gap:4px;font-size:12px">
          <div style="font-weight:700;color:var(--text3)">Metric</div>
          <div style="font-weight:700;text-align:right">Scenario A</div>
          <div style="font-weight:700;text-align:right">Scenario B</div>
          ${[
            ['Injections', resultA.actualInjections.length, resultB.actualInjections.length],
            ['Vials needed', resultA.vialsNeeded, resultB.vialsNeeded],
            ['Syringes needed', resultA.syringesNeeded, resultB.syringesNeeded],
            ['Total cost', '$'+resultA.totalCost.toFixed(0), '$'+resultB.totalCost.toFixed(0)],
            ['Total product', resultA.totalDoseMg.toFixed(1)+' '+resultA.doseUnit, resultB.totalDoseMg.toFixed(1)+' '+resultB.doseUnit],
            ['Product remaining', resultA.productRemaining.toFixed(1)+' '+resultA.doseUnit, resultB.productRemaining.toFixed(1)+' '+resultB.doseUnit],
            ['Vials short', resultA.vialsShort||'None', resultB.vialsShort||'None'],
            ['Expiring vials', resultA.expiringVials.length||'None', resultB.expiringVials.length||'None'],
          ].map(([label, a, b]) => `
          <div style="padding:4px 0;border-top:1px solid var(--border)">${label}</div>
          <div style="padding:4px 0;border-top:1px solid var(--border);text-align:right">${a}</div>
          <div style="padding:4px 0;border-top:1px solid var(--border);text-align:right">${b}</div>`).join('')}
        </div>
      </div>
    </div>` : ''}
  </div>`
}

// ══════════════════════════════════════════════════════
// RENDER: EMERGENCY INFORMATION CARD
// ══════════════════════════════════════════════════════

function renderEmergencyCardTab() {
  var activeUsers = (S.users||[]).filter(function(u){return u.active})
  var currentUser = S._emergencyUser || (activeUsers[0]?activeUsers[0].id:'')
  var currentUserObj = activeUsers.find(function(u){return u.id===currentUser}) || {}
  var currentUserName = currentUserObj.name || ''
  var today = new Date()
  var tenDaysAgo = localDateOffset(-10)
  var todayStr = localDateStr(today)
  var editing = S._iceEditing || false

  if (!S.settings.iceData) S.settings.iceData = {}
  if (!S.settings.iceData[currentUser]) S.settings.iceData[currentUser] = {
    emergencyContacts: [{ name: '', phone: '', relation: '' }],
    bloodType: '', allergies: '', conditions: '', medications: '',
    doctorName: '', doctorPhone: '', notes: ''
  }
  var ice = S.settings.iceData[currentUser]

  // Migrate old global contact
  if (S.settings.emergencyContact && S.settings.emergencyContact.name && !ice.emergencyContacts[0].name) {
    ice.emergencyContacts[0] = { name: S.settings.emergencyContact.name, phone: S.settings.emergencyContact.phone||'', relation: S.settings.emergencyContact.relation||'' }
  }

  var hasData = ice.emergencyContacts.some(function(c){return c.name}) || ice.bloodType || ice.allergies || ice.conditions || ice.doctorName

  // Recent injections
  var recentInj = (S.injections||[]).filter(function(inj) {
    if (inj.date < tenDaysAgo || inj.date > todayStr) return false
    if (currentUser && inj.userId && inj.userId !== currentUser) return false
    return true
  }).sort(function(a,b){return b.date.localeCompare(a.date)})

  // Active supplements
  var userSupps = (S.supplements||[]).filter(function(s) {
    if ((s.status||'active') === 'inactive') return false
    var by = s.takenBy || 'both'
    return by === 'both' || by === currentUser || by === currentUserName.toLowerCase()
  }).sort(function(a,b){return a.name.localeCompare(b.name)})

  // Active protocols
  var doseProtocols = []
  S.peptides.forEach(function(p) {
    if (p.archived) return
    ;(p.dosageProtocols||[]).forEach(function(dp) {
      if (dp.active) doseProtocols.push({ name: p.name, dosage: dp.dosage, frequency: dp.frequency, route: dp.route })
    })
  })

  var userButtons = activeUsers.length > 1 ? activeUsers.map(function(u) {
    return '<button class="btn btn-sm '+(currentUser===u.id?'btn-primary':'btn-secondary')+'" onclick="S._emergencyUser=\''+u.id+'\';S._iceEditing=false;render()">'+esc(u.name)+'</button>'
  }).join('') : ''

  // ── EDIT MODE ──
  if (editing || !hasData) {
    var contactRows = ice.emergencyContacts.map(function(c, i) {
      return '<div style="display:grid;grid-template-columns:1fr 1fr 1fr auto;gap:8px;align-items:end;margin-bottom:6px">' +
        '<div class="form-group"><label class="form-label">Name</label><input class="form-input" placeholder="Contact name" value="'+esc(c.name)+'" onchange="S.settings.iceData[\''+currentUser+'\'].emergencyContacts['+i+'].name=this.value"></div>' +
        '<div class="form-group"><label class="form-label">Phone</label><input class="form-input" placeholder="Phone number" value="'+esc(c.phone)+'" onchange="S.settings.iceData[\''+currentUser+'\'].emergencyContacts['+i+'].phone=this.value"></div>' +
        '<div class="form-group"><label class="form-label">Relationship</label><input class="form-input" placeholder="e.g. Spouse" value="'+esc(c.relation)+'" onchange="S.settings.iceData[\''+currentUser+'\'].emergencyContacts['+i+'].relation=this.value"></div>' +
        (ice.emergencyContacts.length > 1 ? '<button class="btn-icon" style="margin-bottom:2px" onclick="S.settings.iceData[\''+currentUser+'\'].emergencyContacts.splice('+i+',1);render()" title="Remove">'+ICONS.close+'</button>' : '<div></div>') +
      '</div>'
    }).join('')

    var makeField = function(label, key, placeholder, isTextarea) {
      var val = ice[key] || ''
      if (isTextarea) return '<div class="form-group"><label class="form-label">'+label+'</label><textarea class="form-input" rows="2" placeholder="'+placeholder+'" onchange="S.settings.iceData[\''+currentUser+'\'].'+key+'=this.value">'+esc(val)+'</textarea></div>'
      return '<div class="form-group"><label class="form-label">'+label+'</label><input class="form-input" placeholder="'+placeholder+'" value="'+esc(val)+'" onchange="S.settings.iceData[\''+currentUser+'\'].'+key+'=this.value"></div>'
    }

    return '<div class="tab-content" style="animation:fadeIn var(--dur-slow) var(--ease)">' +
      '<div class="row" style="margin-bottom:20px;flex-wrap:wrap;gap:10px"><h2 style="margin:0">Edit Emergency Card</h2><div class="spacer"></div>'+userButtons+'</div>' +
      '<div style="max-width:680px">' +
        '<div style="background:var(--accent-gradient);color:white;padding:18px 24px;border-radius:var(--r) var(--r) 0 0;display:flex;align-items:center;gap:14px">' +
          '<div style="width:48px;height:48px;background:rgba(255,255,255,.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:800">'+(currentUserName?currentUserName.charAt(0).toUpperCase():'?')+'</div>' +
          '<div><div style="font-size:18px;font-weight:700">'+esc(currentUserName||'Select User')+'</div><div style="opacity:.7;font-size:13px">Emergency Information Card</div></div>' +
        '</div>' +
        '<div class="card" style="border-radius:0 0 var(--r) var(--r);border-top:none"><div class="card-body" style="display:flex;flex-direction:column;gap:16px">' +
          '<div><div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px"><div style="font-size:var(--fs-sm);font-weight:var(--fw-bold);color:var(--red);text-transform:uppercase;letter-spacing:var(--ls-wider)">Emergency Contacts</div><button class="btn btn-xs btn-ghost" onclick="S.settings.iceData[\''+currentUser+'\'].emergencyContacts.push({name:\'\',phone:\'\',relation:\'\'});render()">+ Add Contact</button></div>'+contactRows+'</div>' +
          '<div class="divider" style="margin:4px 0"></div>' +
          '<div style="font-size:var(--fs-sm);font-weight:var(--fw-bold);color:var(--yellow);text-transform:uppercase;letter-spacing:var(--ls-wider);margin-bottom:2px">Medical Information</div>' +
          '<div class="form-row form-row-3">'+makeField('Blood Type','bloodType','e.g. O+')+makeField('Doctor Name','doctorName','Primary physician')+makeField('Doctor Phone','doctorPhone','Phone number')+'</div>' +
          makeField('Allergies','allergies','Drug or food allergies',true) +
          makeField('Medical Conditions','conditions','Existing medical conditions',true) +
          makeField('Other Medications','medications','Non-peptide prescription medications',true) +
          makeField('Additional Notes','notes','Critical info for medical personnel',true) +
        '</div>' +
        '<div style="padding:16px 24px;border-top:1px solid var(--border);display:flex;justify-content:flex-end;gap:10px">' +
          (hasData?'<button class="btn btn-secondary" onclick="S._iceEditing=false;render()">Cancel</button>':'') +
          '<button class="btn btn-primary" onclick="save();S._iceEditing=false;showToast(\'Emergency card saved\');render()">Save Card</button>' +
        '</div></div>' +
      '</div>' +
    '</div>'
  }

  // ── VIEW MODE — polished card only ──
  var contactsHtml = ice.emergencyContacts.filter(function(c){return c.name}).map(function(c) {
    return '<div style="display:flex;justify-content:space-between;align-items:center;padding:4px 0;border-bottom:1px solid rgba(220,38,38,.1)">' +
      '<div><span style="font-size:15px;font-weight:700">'+esc(c.name)+'</span>'+(c.relation?' <span style="color:#666;font-size:13px">('+esc(c.relation)+')</span>':'')+'</div>' +
      (c.phone?'<div style="font-size:15px;font-weight:700;color:#dc2626">'+esc(c.phone)+'</div>':'') +
    '</div>'
  }).join('')

  var protocolRows = doseProtocols.map(function(dp) {
    return '<div style="display:flex;justify-content:space-between;padding:5px 0;font-size:13px;border-bottom:1px solid #f3f4f6"><span style="font-weight:600">'+esc(dp.name)+'</span><span style="color:#666">'+esc(dp.dosage||'')+' '+esc(dp.frequency||'')+' via '+esc(dp.route||'')+'</span></div>'
  }).join('')

  var injRows = recentInj.slice(0, 20).map(function(inj) {
    return '<div style="display:flex;justify-content:space-between;padding:3px 0;font-size:12px;border-bottom:1px solid #f3f4f6"><span style="color:#666;min-width:80px">'+inj.date+'</span><span style="font-weight:600;flex:1;padding:0 8px">'+esc(inj.peptideName||'')+'</span><span style="color:#333">'+esc(inj.dosage||'')+(inj.time?' &middot; '+esc(inj.time):'')+'</span></div>'
  }).join('')

  var suppRowFn = function(s) {
    return '<div style="font-size:11px;padding:2px 0;border-bottom:1px solid #f3f4f6"><span style="font-weight:600">'+esc(s.name)+'</span><span style="color:#666">'+(s.strength?' '+esc(s.strength):'')+'</span></div>'
  }
  var amSupps = userSupps.filter(function(s){return s.timeOfDay==='am'||s.timeOfDay==='both'})
  var noonSupps = userSupps.filter(function(s){return s.timeOfDay==='noon'})
  var pmSupps = userSupps.filter(function(s){return s.timeOfDay==='pm'||s.timeOfDay==='both'})
  var protoSupps = userSupps.filter(function(s){return s.timeOfDay==='protocol'})
  var suppSection = ''
  if (userSupps.length) {
    suppSection = '<div style="margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#555;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:8px;border-bottom:2px solid #e5e7eb;padding-bottom:4px">Current Supplements ('+userSupps.length+')</div>'
    if (amSupps.length) suppSection += '<div style="font-size:10px;font-weight:800;color:#b45309;margin:8px 0 4px">\u2600\uFE0F MORNING ('+amSupps.length+')</div><div style="display:grid;grid-template-columns:repeat(2,1fr);gap:2px 16px">'+amSupps.map(suppRowFn).join('')+'</div>'
    if (noonSupps.length) suppSection += '<div style="font-size:10px;font-weight:800;color:#0f766e;margin:8px 0 4px">\uD83D\uDD5B NOON / LUNCH ('+noonSupps.length+')</div><div style="display:grid;grid-template-columns:repeat(2,1fr);gap:2px 16px">'+noonSupps.map(suppRowFn).join('')+'</div>'
    if (pmSupps.length) suppSection += '<div style="font-size:10px;font-weight:800;color:#4338ca;margin:8px 0 4px">\uD83C\uDF19 EVENING ('+pmSupps.length+')</div><div style="display:grid;grid-template-columns:repeat(2,1fr);gap:2px 16px">'+pmSupps.map(suppRowFn).join('')+'</div>'
    if (protoSupps.length) suppSection += '<div style="font-size:10px;font-weight:800;color:#166534;margin:8px 0 4px">\uD83E\uDDEC PROTOCOL ('+protoSupps.length+')</div><div style="display:grid;grid-template-columns:repeat(2,1fr);gap:2px 16px">'+protoSupps.map(suppRowFn).join('')+'</div>'
    suppSection += '</div>'
  }

  return '<div class="tab-content" style="animation:fadeIn var(--dur-slow) var(--ease)">' +
    '<div class="row" style="margin-bottom:20px;flex-wrap:wrap;gap:10px"><h2 style="margin:0">Emergency Information Card</h2><div class="spacer"></div>'+userButtons+
    '<button class="btn btn-sm btn-secondary" onclick="S._iceEditing=true;render()">Edit</button>' +
    '<button class="btn btn-sm btn-primary" onclick="printEmergencyCard()">Print</button></div>' +
    '<div id="emergency-card-preview" style="max-width:700px"><div style="border:2px solid #333;border-radius:12px;overflow:hidden;background:#fff;color:#000">' +
      '<div style="background:linear-gradient(135deg,#dc2626,#b91c1c);color:#fff;padding:18px 24px;display:flex;align-items:center;gap:14px">' +
        '<div style="width:52px;height:52px;background:rgba(255,255,255,.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:800">'+(currentUserName?currentUserName.charAt(0).toUpperCase():'?')+'</div>' +
        '<div><div style="font-size:22px;font-weight:800;letter-spacing:.5px">MEDICAL INFORMATION</div><div style="font-size:15px;opacity:.95">'+esc(currentUserName)+(ice.bloodType?' &middot; Blood Type: <strong>'+esc(ice.bloodType)+'</strong>':'')+'</div></div>' +
      '</div>' +
      '<div style="padding:18px 24px">' +
        (contactsHtml?'<div style="background:#fef2f2;border:1px solid #fca5a5;border-radius:8px;padding:14px 18px;margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#991b1b;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:8px">Emergency Contacts</div>'+contactsHtml+'</div>':'') +
        ((ice.allergies||ice.conditions||ice.medications)?'<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:8px;padding:14px 18px;margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#9a3412;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:8px">Medical Information</div>'+(ice.allergies?'<div style="margin-bottom:8px"><span style="font-size:11px;font-weight:800;color:#888">ALLERGIES:</span> <span style="font-size:14px;font-weight:600;color:#c2410c">'+esc(ice.allergies)+'</span></div>':'')+(ice.conditions?'<div style="margin-bottom:8px"><span style="font-size:11px;font-weight:800;color:#888">CONDITIONS:</span> <span style="font-size:14px">'+esc(ice.conditions)+'</span></div>':'')+(ice.medications?'<div><span style="font-size:11px;font-weight:800;color:#888">OTHER MEDICATIONS:</span> <span style="font-size:14px">'+esc(ice.medications)+'</span></div>':'')+'</div>':'') +
        (ice.doctorName?'<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:12px 18px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:center"><div><div style="font-size:11px;font-weight:800;color:#166534;text-transform:uppercase;letter-spacing:1.2px">Primary Physician</div><div style="font-size:15px;font-weight:700">'+esc(ice.doctorName)+'</div></div>'+(ice.doctorPhone?'<div style="font-size:15px;font-weight:700;color:#166534">'+esc(ice.doctorPhone)+'</div>':'')+'</div>':'') +
        (doseProtocols.length?'<div style="margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#555;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:8px;border-bottom:2px solid #e5e7eb;padding-bottom:4px">Active Protocols</div>'+protocolRows+'</div>':'') +
        (recentInj.length?'<div style="margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#555;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:8px;border-bottom:2px solid #e5e7eb;padding-bottom:4px">Recent Administrations (Last 10 Days)</div>'+injRows+'</div>':'') +
        suppSection +
        (ice.notes?'<div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:12px 18px;margin-bottom:16px"><div style="font-size:11px;font-weight:800;color:#0369a1;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:4px">Additional Notes</div><div style="font-size:13px">'+esc(ice.notes)+'</div></div>':'') +
        '<div style="text-align:center;font-size:10px;color:#999;margin-top:8px;padding-top:10px;border-top:1px solid #e5e7eb">PeptideVault Emergency Card &middot; Updated '+todayStr+'</div>' +
      '</div></div></div></div>'
}

function printEmergencyCard() {
  var card = document.getElementById('emergency-card-preview')
  if (!card) return
  var w = window.open('', '_blank', 'width=800,height=600')
  w.document.write('<!DOCTYPE html><html><head><title>Emergency Card</title><style>body{margin:20px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif}@media print{body{margin:0}}</style></head><body>' + card.innerHTML + '<script>setTimeout(function(){window.print()},300)<\/script></body></html>')
  w.document.close()
}

function renderLocationsTab() {
  if (S.locationView !== 'supplies' && typeof window.renderPeptideVaultMap === 'function') return window.renderPeptideVaultMap()
  if (S.locationView === 'supplies' && typeof window.renderSupplyLocationsView === 'function') return window.renderSupplyLocationsView()
  // Build inventory map: locationId → [{ peptide, sku, qty }]
  const locMap = {}
  for (const p of S.peptides) {
    for (const s of (p.skus||[])) {
      for (const l of (s.locations||[])) {
        if (!l.locationId || !l.qty) continue
        if (!locMap[l.locationId]) locMap[l.locationId] = []
        locMap[l.locationId].push({ peptide: p, sku: s, qty: l.qty })
      }
    }
  }

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:18px;flex-wrap:wrap;gap:8px">
      <div><h2 style="font-size:20px;font-weight:700">Supply Locations</h2><div style="font-size:12px;color:var(--text3)">Original flat-location tracking remains active for supplies</div></div>
      <div class="spacer"></div>
      <button class="btn btn-primary" onclick="showPeptideVaultMap()">Peptide Vault Map</button>
      <button class="btn btn-secondary" onclick="importLocationCSV()">${ICONS.plus} Import CSV</button>
      <button class="btn btn-secondary" onclick="importStorageInventoryCSV()">${ICONS.plus} Import Inventory</button>
      ${S.storageLocations.length ? `<button class="btn btn-danger" onclick="openModal('clearInventory')">${ICONS.trash} Clear Location Inventory</button>` : ''}
      ${S.peptides.some(p=>(p.skus||[]).some(s=>(s.transactions||[]).some(t=>/^Imported into /.test(t.notes||'')))) ? `<button class="btn btn-secondary" onclick="appConfirm('Remove transactions created by the old storage import (and their offsetting bulk removals)? This recalculates stock totals. Recommended only on your source-of-truth device.',()=>{cleanupImportTransactions(true)})" title="Undo the old import that inflated SKU stock">⚠ Fix Import Stock</button>` : ''}
      ${S.storageLocations.length ? `<button class="btn btn-danger" onclick="openModal('deleteLocations')">${ICONS.trash} Delete Locations</button>` : ''}
      ${countImportTransactions().importTx ? `<button class="btn btn-secondary" onclick="openImportCleanup()" title="Remove leftover Imported-into stock transactions">⚠ Clean Up Import Txns (${countImportTransactions().importTx})</button>` : ''}
      <button class="btn btn-primary" onclick="openModal('addLocation')">${ICONS.plus} Add Location</button>
    </div>

    <!-- Master location list -->
    <div class="card" style="margin-bottom:24px">
      <div class="card-header">
        <div class="card-title">Storage Locations</div>
        <span style="font-size:12px;color:var(--text3)">${S.storageLocations.length} location${S.storageLocations.length!==1?'s':''}</span>
      </div>
      ${S.storageLocations.length === 0 ? `
        <div class="empty-state" style="padding:32px">
          <div class="empty-icon">📍</div>
          <p>No locations yet</p>
          <span>Click "Add Location" to create your first storage location</span>
        </div>
      ` : `
        <table class="tbl">
          <thead><tr><th>Location</th><th>Peptides In Storage</th><th>Slots Available</th><th>Actions</th></tr></thead>
          <tbody>
            ${S.storageLocations.map(loc => {
              const entries = locMap[loc.id] || []
              // Live vial count currently in this location (updates as SKU location qtys change)
              const total = entries.reduce((a, e) => a + e.qty, 0)
              const capacity = +(loc.totalCapacity || 0)
              const available = capacity > 0 ? capacity - total : null
              const slotsBadge = capacity > 0
                ? `<span class="badge ${available < 0 ? 'badge-red' : available === 0 ? 'badge-yellow' : 'badge-green'}">${available} of ${capacity}</span>`
                : `<span style="color:var(--text4);font-size:12px">No capacity set</span>`
              return `<tr>
                <td style="font-weight:600;font-size:14px">📍 ${esc(loc.name)}</td>
                <td style="color:var(--text2)">${total} vial${total!==1?'s':''}</td>
                <td>${slotsBadge}</td>
                <td>
                  <div class="row" style="gap:4px">
                    <button class="btn btn-secondary btn-xs" onclick="openModal('editLocation',{locId:'${loc.id}'})">${ICONS.edit} Edit</button>
                    <button class="btn btn-danger btn-xs" onclick="deleteLocation('${loc.id}')">${ICONS.trash}</button>
                  </div>
                </td>
              </tr>`
            }).join('')}
          </tbody>
        </table>
      `}
    </div>

    <!-- Inventory by location -->
    ${S.storageLocations.length > 0 ? `
    <h3 style="font-size:16px;font-weight:700;margin-bottom:14px">Inventory by Location</h3>
    ${S.storageLocations.filter(loc => locMap[loc.id]?.length).map(loc => {
      const entries = locMap[loc.id] || []
      const totalQty = entries.reduce((a, e) => a + e.qty, 0)
      return `
      <div class="card" style="margin-bottom:14px">
        <div class="card-header">
          <div class="row" style="gap:8px;align-items:center">
            <span style="font-size:16px">📍</span>
            <div class="card-title" style="font-size:15px">${esc(loc.name)}</div>
            <span class="badge badge-blue">${totalQty} total vials</span>
          </div>
          <span style="font-size:12px;color:var(--text3)">${entries.length} SKU${entries.length!==1?'s':''}</span>
        </div>
        <table class="tbl">
          <thead>
            <tr><th>Peptide</th><th>SKU / Lot</th><th>Vendor</th><th>Purity</th><th style="text-align:right">Qty Here</th></tr>
          </thead>
          <tbody>
            ${entries.map(e => `
            <tr onclick="selectPeptide('${e.peptide.id}');setTab('peptides')" style="cursor:pointer" title="View in Inventory">
              <td style="font-weight:600">${esc(e.peptide.name)}</td>
              <td>
                ${e.sku.barcode ? `<span class="mono" style="font-size:12px;color:var(--text3)">▌ ${esc(e.sku.barcode)}</span>` : ''}
                ${e.sku.lotNumber ? `<span style="font-size:11px;color:var(--text4);margin-left:6px">Lot: ${esc(e.sku.lotNumber)}</span>` : ''}
                ${!e.sku.barcode && !e.sku.lotNumber ? '<span style="color:var(--text4);font-size:12px">—</span>' : ''}
              </td>
              <td style="color:var(--text2);font-size:13px">${esc(e.sku.vendor||'—')}</td>
              <td style="color:var(--text2);font-size:13px">${esc(e.sku.purity||'—')}</td>
              <td style="text-align:right;font-weight:700;font-size:15px;color:var(--blue)">${e.qty}</td>
            </tr>`).join('')}
          </tbody>
        </table>
      </div>`
    }).join('')}
    ${S.storageLocations.every(loc => !(locMap[loc.id]?.length)) ? `
    <div style="color:var(--text4);font-size:13px;text-align:center;padding:24px">
      No inventory assigned to locations yet — edit a SKU to assign quantities to locations
    </div>` : ''}
    ` : ''}

    <!-- Not in Storage -->
    ${(() => {
      const notStored = []
      for (const p of S.peptides) {
        for (const s of (p.skus || [])) {
          const onHand = skuQty(s)
          const inStorage = (s.locations || []).reduce((a, l) => a + (l.qty || 0), 0)
          const diff = onHand - inStorage
          if (diff > 0) notStored.push({ peptide: p, sku: s, qty: diff, onHand, inStorage })
        }
      }
      if (!notStored.length) return ''
      const totalUnlocated = notStored.reduce((a, e) => a + e.qty, 0)
      return `
    <h3 style="font-size:16px;font-weight:700;margin-bottom:14px">Not in Storage</h3>
    <div class="card" style="margin-bottom:14px">
      <div class="card-header">
        <div class="row" style="gap:8px;align-items:center">
          <span style="font-size:16px">📦</span>
          <div class="card-title" style="font-size:15px">Unassigned Inventory</div>
          <span class="badge badge-yellow">${totalUnlocated} vial${totalUnlocated!==1?'s':''} not in storage</span>
        </div>
        <span style="font-size:12px;color:var(--text3)">${notStored.length} SKU${notStored.length!==1?'s':''}</span>
      </div>
      <table class="tbl">
        <thead>
          <tr><th>Peptide</th><th>SKU / Lot</th><th>Vendor</th><th style="text-align:right">On Hand</th><th style="text-align:right">In Storage</th><th style="text-align:right;color:var(--amber)">Not Stored</th></tr>
        </thead>
        <tbody>
          ${notStored.map(e => `
          <tr onclick="selectPeptide('${e.peptide.id}');setTab('peptides')" style="cursor:pointer" title="View in Inventory">
            <td style="font-weight:600">${esc(e.peptide.name)}</td>
            <td>
              ${e.sku.barcode ? `<span class="mono" style="font-size:12px;color:var(--text3)">▌ ${esc(e.sku.barcode)}</span>` : ''}
              ${e.sku.lotNumber ? `<span style="font-size:11px;color:var(--text4);margin-left:6px">Lot: ${esc(e.sku.lotNumber)}</span>` : ''}
              ${!e.sku.barcode && !e.sku.lotNumber ? '<span style="color:var(--text4);font-size:12px">—</span>' : ''}
            </td>
            <td style="color:var(--text2);font-size:13px">${esc(e.sku.vendor||'—')}</td>
            <td style="text-align:right;font-size:13px;color:var(--text2)">${e.onHand}</td>
            <td style="text-align:right;font-size:13px;color:var(--text2)">${e.inStorage}</td>
            <td style="text-align:right;font-weight:700;font-size:15px;color:var(--amber)">${e.qty}</td>
          </tr>`).join('')}
        </tbody>
      </table>
    </div>`
    })()}
  </div>`
}


function renderDocsTab() {
  const tabDefs = [
    { id:'all', label:'All' },
    { id:'protocol', label:'Protocol' },
    { id:'health', label:'Health Information' },
    { id:'research', label:'Research' },
    { id:'other', label:'Other' },
  ]
  const docs = docsByType(S.docTab)

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:18px">
      <h2 style="font-size:20px;font-weight:700">Document Library</h2>
      <div class="spacer"></div>
      <input class="form-input" style="width:200px" placeholder="Search documents…" value="${esc(S.docSearch)}" oninput="S.docSearch=this.value;render()">
      <button class="btn btn-primary" onclick="openModal('addDoc')">${ICONS.plus} Add Document</button>
    </div>

    <div class="doc-tab-bar" style="margin-bottom:16px;-webkit-app-region:no-drag">
      ${tabDefs.map(t => `<button class="doc-tab ${S.docTab===t.id?'active':''}" onclick="S.docTab='${t.id}';render()">${esc(t.label)}</button>`).join('')}
    </div>

    <div class="card">
      ${docs.length === 0 ? `
        <div class="empty-state">
          <div class="empty-icon">📄</div>
          <p>${S.docSearch ? 'No results found' : 'No documents yet'}</p>
          <span>${S.docSearch ? 'Try a different search' : 'Click "Add Document" to get started'}</span>
        </div>
      ` : `
        <table class="tbl">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            ${docs.map(doc => {
              const linkedPeptide = isDocLinkedToPeptide(doc.id)
              return `<tr>
                <td>
                  <div style="font-weight:500">${esc(doc.name)}</div>
                  ${doc.originalName ? `<div style="font-size:11px;color:var(--text4)">${esc(doc.originalName)}</div>` : ''}
                </td>
                <td><span class="doc-type-badge ${docTypeClass(doc.type)}">${docTypeName(doc.type)}</span></td>
                <td style="color:var(--text3);font-size:12px">${fmt(doc.addedAt)}</td>
                <td>
                  <div class="row" style="gap:4px">
                    <button class="btn btn-ghost btn-xs" onclick="openDocFile(getDoc('${doc.id}'))" title="Open">${ICONS.eye} Open</button>
                    <button class="btn btn-secondary btn-xs" onclick="openModal('editDoc',{docId:'${doc.id}'})" title="Edit">${ICONS.edit} Edit</button>
                    <button class="btn btn-danger btn-xs" onclick="deleteDoc('${doc.id}')" title="Delete">${ICONS.trash}</button>
                  </div>
                </td>
              </tr>`
            }).join('')}
          </tbody>
        </table>
      `}
    </div>
  </div>`
}

export {
  runSimulation,
  renderSimulatorTab,
  renderEmergencyCardTab,
  printEmergencyCard,
  renderLocationsTab,
  renderDocsTab
}
